module.exports = __webpack_public_path__ + "static/media/71.f7954071.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/71.jpg
// module id = 1009
// module chunks = 0